import React from 'react'
import styled from 'styled-components'

export default ({ children, color = null }) => {
  return <Title color={color}>{children}</Title>
}

const Title = styled.div`
  ${(props) => props.theme.titleSizing()};
  margin-bottom: 0.4em;
  color: ${(props) => props.theme.pageTheme.headingPrimary};
  span {
    color: ${(props) => props.color || props.theme.pageTheme.accentPrimary};
  }
`
